import React from 'react';
import { Result,Button } from 'antd';
import { GlobalStore } from 'stores/Global';

export const NotFoundRoute = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, we cannot find page you're looking for."
      extra={
        <Button type="primary" onClick={() => GlobalStore.navigate('/')}>
          Back Home
        </Button>
      }
    />
  );
};